import { EventProps, ItemType, EcommerceType } from "./eventTypes";
import { executeGaEvent } from "./gaConfig";

export const pushTagEvent = (event: EventProps) => executeGaEvent(event);

export const homeTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:home",
  });
};

export const purchaseTagEvent = (data: EcommerceType) => {
  executeGaEvent({
    event: "purchase",
    ...data,
  });
};

export const paymentInfoTagEvent = (item: ItemType) => {
  executeGaEvent({
    event: "add_payment_info",
    item: {
      ...item,
      currency: "BRL",
    },
  });
};

export const tagBeginCheckout = (item: ItemType) => {
  executeGaEvent({
    event: "begin_checkout",
    item: {
      currency: "BRL",
      ...item,
    },
  });
};

export const newRegisterPhoneTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-phone",
  });
};

export const newRegisterSmsTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-sms",
  });
};

export const newRegisterSmsPortabilityTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-sms-portability",
  });
};

export const newRegisterBalanceTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-balance",
  });
};

export const newRegisterSuccessTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-success",
  });
};

export const newRegisterSuccessPortabilityTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-success-portability",
  });
};

export const newRegisterConfirmTagEvents = (event: EventProps) => {
  executeGaEvent({
    ...event,
    custom_section: "claro-flex:new-register-confirm",
  });
};
